import { Box } from "@gemini/core";
import { Button, Link } from "@gemini/ui";

import { useTranslate } from "../../../utils/useTranslate";
import { BRAND_CONFIGURATION } from "../../../../configs/brands";

export const NotFoundErrorPageButtons = () => {
  const t = useTranslate();

  return (
    <Box
      paddingHorizontal={{ "breakpoint.base": "spacing.16" }}
      display="inline-flex"
      flexDirection="column"
      alignItems="center"
      alignSelf="stretch"
      gap="spacing.12"
    >
      <Button
        variant="primary"
        href="/"
        isFullWidth={{
          "breakpoint.base": true,
          "breakpoint.sm": false,
        }}
      >
        {t("notFoundError.primaryButton")}
      </Button>
      {BRAND_CONFIGURATION.errorEmailAddress && (
        <Link href={`mailto:${BRAND_CONFIGURATION.errorEmailAddress}`}>
          {t("notFoundError.secondaryButton")}
        </Link>
      )}
    </Box>
  );
};
